import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const MARKETING_SITE_URL = import.meta.env.VITE_MARKETING_URL || 'https://siteawake.com';

/**
 * Root redirect component
 * - Authenticated users -> /monitors
 * - Unauthenticated users -> external marketing site
 */
export function RootRedirect() {
  const navigate = useNavigate();
  const { isAuthenticated, isLoading } = useAuth();

  useEffect(() => {
    if (isLoading) return;

    if (isAuthenticated) {
      navigate('/monitors', { replace: true });
    } else {
      // Redirect to external marketing site
      window.location.href = MARKETING_SITE_URL;
    }
  }, [isAuthenticated, isLoading, navigate]);

  // Show loading while checking auth
  return (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
      <CircularProgress />
    </Box>
  );
}

export default RootRedirect;
